<div class="DeleteContactGroup" [formGroup]="inputForm">
  <p class="DeleteContactGroup__prompt">
    Are you sure you want to delete {{ contactGroup.group_name }} (id
    {{ contactGroup.group_id }})?
  </p>
  <mat-checkbox formControlName="purge_mode" class="DeleteContactGroup__checkbox">
    <span class="DeleteContactGroup__checkbox-label">
      <span
        *ngFor="let line of purgeModeLines"
        class="DeleteContactGroup__checkbox-line">{{ line }}</span>
    </span>
  </mat-checkbox>
</div>
